// =====================================================================
// Google Maps istemci anahtarı — TEK KAYNAK.
//
// YAŞANAN OLAY (Holideus RU, 2026-10-03): "Became a member" ekranındaki adres
// alanında harita yüklenmiyor ve Google şu hatayı basıyordu:
//     "You must use an API key to authenticate each request..."
// TourZone'da çalışıyordu, Holideus'ta çalışmıyordu.
//
// NEDEN: anahtar YALNIZ `process.env.REACT_APP_GOGOLE_MAP_API`'den okunuyordu ve CRA
// bunu BUILD ANINDA gömer. TR tarafında değer Cloudflare Pages ortam değişkeninden
// geliyor; RU tarafında newfrontend GitHub workflow'unda derleniyor ve o adımda
// HİÇBİR `REACT_APP_*` verilmiyor (`newfrontend/.env` de .gitignore'da, yani CI
// checkout'unda yok). Sonuç: RU paketine BOŞ anahtar gömülüyordu.
//
// ÇÖZÜM — runtime-config: anahtar artık önce `window.__TZ_CONFIG__.googleMapKey`'ten
// okunur, yoksa eski ortam değişkenine düşer. Aynı imaj iki pazarda da çalışsın diye
// apiBase/imageBase/captcha zaten böyle yapılıyor (bkz. Libs/Api/Config.js,
// Libs/Captcha/captchaConfig.js) — bu dosya o deseni sürdürüyor.
//
// Faydası: anahtar değişince YENİDEN DERLEME gerekmez, sunucudaki runtime-config.js
// güncellenir. TR'de runtime-config olmadığı için davranış BİREBİR aynı kalır.
//
// GİZLİLİK: istemci anahtarı gizli değildir (sayfa kaynağında görünür). Korunma
// yolu Google Cloud Console'daki HTTP referrer kısıtıdır — ölçüldü (2026-10-03):
// bu anahtarda referrer kısıtı YOK, yani her alan adından kullanılabilir. Faturalama
// açısından kısıtlanması önerilir; kısıtlanırsa holideus.ru da izin listesine girmeli.
// =====================================================================

const runtime = (typeof window !== 'undefined' && window.__TZ_CONFIG__) || {};

/** Google Maps JS/Static API istemci anahtarı; tanımsızsa ''. */
export const GOOGLE_MAP_KEY = String(
    runtime.googleMapKey || process.env.REACT_APP_GOGOLE_MAP_API || ''
);

export default GOOGLE_MAP_KEY;
